import React, { useEffect } from "react";
import Progress from "components/stamp/progress";

export default function StampWrap(props) {
  const detailData = props.detailData;

  useEffect(() => {
    console.log("detailData: ", detailData);
  }, []);

  return (
    <div className="type-gauge detail-gauge">
      <Progress item={detailData} iconYn="N" />
      <div className="cnt-info">
        {detailData.withdrawFlag == "0" ? (
          <>
            <p className="cnt">
              누적스탬프{" "}
              <b>
                {detailData.accCount}/{detailData.totalMaxCount}
              </b>
            </p>
          </>
        ) : (
          <>
            <p className="cnt">
              보유스탬프 <b>{detailData.etCount}</b>
            </p>
            <p className="cnt-detail">
              누적스탬프 {detailData.accCount}/{detailData.totalMaxCount}
            </p>
          </>
        )}
      </div>
    </div>
  );
}
